"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.email = void 0;
exports.email = {
    hello: 'hello@feather-insurance.com',
    help: 'help@feather-insurance.com',
    careers: 'careers@feather-insurance.com',
    security: 'security@feather-insurance.com',
};
